import AxiosInstance from 'src/shared/services/axios/interceptor';
import { MemberUpdateRespons } from 'src/modules/member/models/memberUpdateRespons';
import { PagedResult } from 'src/shared/models/pagedResult';
import { MemberUpdateRequest } from 'src/modules/member/models/memberUpdateRequest';
import { setPagingParams } from 'src/shared/functions/createPagingParams';

const controller = 'MemberUpdate';

export const getMemberUpdate = (pageIndex: number, pageSize: number, sortCol: string, sortDir: string) => {
  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<MemberUpdateRespons>>(endpoint);
};

export const getMemberUpdateByMemberId = (memberUpdateId) => {
  const endpoint = `${controller}/${memberUpdateId}`;
  return AxiosInstance.get<MemberUpdateRespons>(endpoint);
};

export const createMemberUpdate = (memberUpdates: MemberUpdateRequest[]) => {
  const endpoint = `${controller}/Set`;
  return AxiosInstance.put<MemberUpdateRespons>(endpoint, memberUpdates);
};
